import React from "react";
import ReactTooltip from "react-tooltip";
import { FormattedMessage } from "react-intl";

// Utils
import DefaultStates, { predefinedFilters } from "wxrecall/util/DefaultStates";

// WxRecall Components
import { FilterModal } from "wxrecall/components/FilterModal";

// WxRecall SearchResults Components
import TableRow from "wxrecall/components/SearchResults/TableRow";
import { getClone } from "wxrecall/util/util";

export default function ResultRows(props) {
  const rows = props.data.map((r, i) => (
    <TableRow
      key={`${r.recordIdentifier}-${i}`}
      showMeta={props.showMeta}
      data={r}
      tab={props.tab}
      networkManager={props.networkManager}
    />
  ));

  let metaHeader = "";
  let metaFilter = "";
  if (props.showMeta) {
    metaHeader = (
      <th className="metadata">
        <FormattedMessage id="metadata" />
      </th>
    );
    metaFilter = <td className="desktop-only">{props.columnFilters[0]}</td>;
  }

  // Get a list of the products included in the current search
  const currentAlphaProducts = [];
  const lastWeatherSearchURL =
    props.networkManager.lastRequests.get("weatherSearch");
  Array.from(
    getClone(DefaultStates).alphaProducts.keys()
  ).forEach(key => {
    if (lastWeatherSearchURL && lastWeatherSearchURL.match("alpha=" + key)) {
      currentAlphaProducts.push(key);
    }
  });

  // Get a boolean for whether there are any filters available for the current search
  const filtersAvailableForCurrentProducts = currentAlphaProducts.some(
    product => predefinedFilters[product]
  );

  // Get the template for the filter control
  const predefinedFilterControl = (
    <div className="predefined-filter-control">
      {
        // Add the badge counter if any filters have already been applied
        props.selectedFilters.length > 0 && (
          <div className="predefined-filter-badge btn-primary">
            {props.selectedFilters.length}
          </div>
        )
      }
      <button
        data-for="filter_button_tooltip"
        data-tip
        className="btn predefined"
        onClick={FilterModal(
          predefinedFilters,
          props.selectedFilters,
          props.setSelectedFilters
        )}
      >
        <i className="icon-filter" />
      </button>
      <ReactTooltip id="filter_button_tooltip" place="bottom" effect="solid">
        <FormattedMessage
          id="alphaFilters.ADD_REMOVE_FILTERS"
          defaultMessage="Filters"
        />
      </ReactTooltip>
    </div>
  );

  return (
    <table className="table table-striped">
      <thead className="desktop-only">
        <tr>
          {metaHeader}
          <th>
            <FormattedMessage id="bulletin" />
          </th>
        </tr>
      </thead>
      <tbody>
        <tr className="filter-row">
          {metaFilter}
          <td className="bulletin-filters">
            {props.columnFilters[1]}
            {
              // If there are filters available for the current search, add the filter control to the UI
              filtersAvailableForCurrentProducts && predefinedFilterControl
            }
          </td>
        </tr>
        {rows}
      </tbody>
    </table>
  );
}
